export const NAME = 'dieCuttingMachines';